import Location from "./KrLocation.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrLocation = install(Location); // 生成带有 install 方法的组件

export default KrLocation;
